export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"「未来を選ぶ」を提案するメディア型OMOストア「CHOOSEBASE SHIBUYA（チューズベースシブヤ）」の公式サイト。ただ単に便利だから安いから物を買うではなく、思いや意味を知ることで共感が生まれ物を買うという、共感軸の消費を大事にする場所。未来に繋がる「テーマ」を軸に、ブランドと消費者をマッチング。展示商品はオンラインストアでも販売中。"},{"hid":"og:title","property":"og:title","content":"CHOOSEBASE SHIBUYA 店内専用Webカタログ"},{"hid":"og:url","property":"og:url","content":"https://catalog.choosebase.jp"},{"hid":"og:site_name","property":"og:site_name","content":"CHOOSEBASE SHIBUYA 店内専用Webカタログ"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:description","property":"og:description","content":"「未来を選ぶ」を提案するメディア型OMOストア「CHOOSEBASE SHIBUYA（チューズベースシブヤ）」の公式サイト。ただ単に便利だから安いから物を買うではなく、思いや意味を知ることで共感が生まれ物を買うという、共感軸の消費を大事にする場所。未来に繋がる「テーマ」を軸に、ブランドと消費者をマッチング。展示商品はオンラインストアでも販売中。"},{"hid":"og:image","property":"og:image","content":"https://prod-common-image.s3-ap-northeast-1.amazonaws.com/public/catalog/og.jpg"},{"hid":"robots","name":"robots","content":"noindex, nofollow"},{"hid":"google","name":"google","content":"notranslate"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"manifest","href":"/site.webmanifest","crossorigin":"use-credentials"}],"style":[],"script":[],"noscript":[],"title":"CHOOSEBASE SHIBUYA 店内専用Webカタログ","htmlAttrs":{"lang":"ja"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false